import { isAfter, isBefore } from "date-fns"
import { LocalDate, Maybe, localDateToDate } from "@flockcover/flock-svc-core-types"
import { Status } from "@shared/types"

export const generateFleetEntryStatus = (onCoverDate: LocalDate, offCoverDate: Maybe<LocalDate>): Status => {
  const now = new Date()

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()

  if (isBefore(now, localDateToDate(onCoverDate, timeZone))) {
    return `scheduled`
  }
  if (
    offCoverDate &&
    isAfter(now, localDateToDate(offCoverDate, timeZone).setDate(localDateToDate(offCoverDate, timeZone).getDate() + 1))
  ) {
    return `off_cover`
  }
  return `on_cover`
}
